// Where the app finds its API and Cognito, resolved at runtime by
// @jkast90/kast-common/config: each field from, highest first, a
// per-device override (the API URL only: the Settings dialog's
// "dashboard_api_url"), window.RUNTIME_CONFIG (public/config.js, shipped
// with the site and served no-store), the build's env, then a default.

import { createDeploymentConfig } from "@jkast90/kast-common/config";
import { timeoutSignal } from "@jkast90/kast-common/fetch";
import { logger } from "@common/utils/logger";

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  fields: {
    apiUrl: {
      key: "VITE_WORKSPACE_API_BASE_URL",
      storageKey: "dashboard_api_url",
      default: (c) =>
        c.isLocalhost
          ? "https://localhost:8443"
          : `${c.protocol}//${c.hostname}`,
    },
    cognitoDomain: {
      key: "VITE_COGNITO_DOMAIN",
      default: (c) => `https://${c.hostname}:8444`,
    },
    cognitoUiUrl: {
      key: "VITE_COGNITO_UI_URL",
      default: (c) => `https://${c.hostname}:8445`,
    },
    clientId: { key: "VITE_COGNITO_CLIENT_ID", default: "linktapestry-client" },
    /** "true" turns auth off; any other value pins it on (public/config.js says "false"); unset leaves it to the Settings toggle. */
    disableAuth: "DISABLE_AUTH",
  },
});

/** How long a health probe may take. */
const HEALTH_TIMEOUT_MS = 5000;

/** Whether the API and Cognito answer their health checks. */
export async function validateServices(): Promise<{
  api: boolean;
  cognito: boolean;
  ui: boolean;
}> {
  const config = deploymentConfig.get();
  const results = { api: false, cognito: false, ui: true };
  try {
    const res = await fetch(`${config.apiUrl}/health`, {
      method: "GET",
      signal: timeoutSignal(HEALTH_TIMEOUT_MS),
    });
    results.api = res.ok;
  } catch (error) {
    logger.warn("API service not accessible:", error);
  }
  try {
    const res = await fetch(`${config.cognitoDomain}/health`, {
      method: "GET",
      signal: timeoutSignal(HEALTH_TIMEOUT_MS),
    });
    results.cognito = res.ok;
  } catch (error) {
    logger.warn("Cognito service not accessible:", error);
  }
  return results;
}
